// Format a timestamp string from the API as YYYY-MM-DD HH:MM:SS in the
// browser's local timezone.
//
// The API returns two flavours, both UTC:
//   - SQLite datetime('now')  → "2026-05-13 11:04:40"     (no T, no Z)
//   - JS new Date().toISOString() → "2026-06-12T12:46:43.587Z" (T + Z)
//
// Naive `new Date("2026-05-13 11:04:40")` parses as LOCAL time in JS, which
// double-shifts the value. We coerce the SQLite shape into proper ISO UTC
// before constructing the Date so the browser's TZ conversion is correct.
export function fmtTime(s: string | null | undefined): string {
  if (!s) return '—';
  const isoUtc = s.includes('T') ? s : s.replace(' ', 'T') + 'Z';
  const d = new Date(isoUtc);
  if (Number.isNaN(d.getTime())) return s; // fallback to raw if unparseable
  // sv-SE locale renders as "YYYY-MM-DD HH:MM:SS" — closest match to the
  // existing UI style, just timezone-corrected.
  return d.toLocaleString('sv-SE');
}
